import { icon, LeafletMouseEventHandlerFn } from 'leaflet'
import { Marker, Popup } from 'react-leaflet'
import { Anchor } from '@mantine/core'
import { Link } from 'react-router-dom'
import { getDeviceRoute } from 'views/panel/DeviceGroups/Single/getDeviceRoute'
import { TDevice, TDeviceType } from 'shared/types'
import DeviceIcon from 'assets/markers/Device.svg'
import GatewayIcon from 'assets/markers/Gateway.svg'

export const DeviceMarkerIcon = (isActive: boolean) =>
  icon({
    iconUrl: DeviceIcon,
    iconRetinaUrl: DeviceIcon,
    iconSize: [30, 40],
    iconAnchor: [15, 40],
    popupAnchor: [-3, -40],
    className: isActive ? 'marker-blinking' : undefined,
  })

export const GatewayMarkerIcon = (isActive: boolean) =>
  icon({
    iconUrl: GatewayIcon,
    iconRetinaUrl: GatewayIcon,
    iconSize: [30, 40],
    iconAnchor: [15, 40],
    popupAnchor: [-3, -40],
    className: isActive ? 'marker-blinking' : undefined,
  })

export const getMarkerIcon = (type: TDeviceType) => {
  switch (type) {
    case 'LoraGateway':
      return GatewayMarkerIcon
    default:
      return DeviceMarkerIcon
  }
}

export const DeviceMarker = ({
  type,
  name,
  deviceId,
  localization: { latitude, longitude },
  noPopup = false,
  onClick,
  isBlinking = false,
}: Pick<TDevice, 'type' | 'localization'> & {
  noPopup?: boolean
  deviceId?: string
  name?: string
  onClick?: LeafletMouseEventHandlerFn
  isBlinking?: boolean
}) => {
  if (!latitude || !longitude) return null

  const icon = getMarkerIcon(type)

  return (
    <Marker
      eventHandlers={{ click: onClick }}
      icon={icon(isBlinking)}
      position={[latitude, longitude]}
    >
      {(!noPopup || !deviceId || !name) && (
        <Popup>
          <Anchor
            component={Link}
            to={getDeviceRoute(type)(
              deviceId,
              type === 'LoraDevice' ? 'indicators' : 'packets',
            )}
          >
            {name}
          </Anchor>
        </Popup>
      )}
    </Marker>
  )
}
